import DAINumberInput from 'src/DAIComponents/Input/Number/DAINumberInput'
import { useForm } from 'react-hook-form'
import { AppointmentTypeForm, appointmentTypeSchema } from '../SettingsTypes'
import { DAIForm } from 'src/DAIComponents/Form/DAIForm'
import DAIButton from 'src/DAIComponents/Input/Button/DAIButton'
import DAITextBox from 'src/DAIComponents/Input/Text/DAITextBox'
import { zodResolver } from '@hookform/resolvers/zod'

type CreateAppointmentTypeModalProps = {
  onSubmit: (data: AppointmentTypeForm) => void
  onClose: () => void
  initialData?: AppointmentTypeForm
}

export default function CreateAppointmentTypeModal({
  onSubmit,
  onClose,
  initialData,
}: CreateAppointmentTypeModalProps) {
  const {
    register,
    formState: { errors, isSubmitting },
    handleSubmit,
  } = useForm<AppointmentTypeForm>({
    defaultValues: initialData,
    resolver: zodResolver(appointmentTypeSchema),
  })

  return (
    <DAIForm onSubmit={handleSubmit(onSubmit)}>
      <div className="grid grid-cols-2 gap-4">
        <DAITextBox
          name="name"
          label="Name"
          register={register('name')}
          error={errors.name?.message}
        />
        <DAINumberInput
          name="days-advanced"
          step={1}
          label="Days in Advanced"
          register={register('daysInAdvance', { min: 0 })}
          error={errors.daysInAdvance?.message}
        />
        <DAINumberInput
          name="meeting-length"
          step={15}
          label="Default Meeting Length (mins)"
          register={register('defaultMeetingLength', { min: 15 })}
          error={errors.defaultMeetingLength?.message}
        />
      </div>
      <div className="mt-6 flex justify-end gap-2">
        <DAIButton text="Cancel" variant="secondary" onClick={onClose} />
        <DAIButton
          buttonType="submit"
          text={initialData ? 'Save Changes' : 'Create'}
          isLoading={isSubmitting}
        />
      </div>
    </DAIForm>
  )
}
